<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-calendar-range</v-icon>
        <v-toolbar-title>System Configuration - Residence Terms</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'system-configuration-residence-terms-toolbar',
    computed: {
        toolbarColor() {
            return '#1BC5BD';
        }
    }
}
</script>